import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from '@shell/message.service';
import { environment } from '@environments';
import { FacturacionService } from '../../../facturacion.service';
import { FacturaPrefijoPipe } from "@shared/pipes/factura-prefijo.pipe";
import { FacturaNumeroPipe } from "@shared/pipes/factura-numero.pipe";
import { RefacturacionFactura } from "@shared/models/facturacion/RefacturacionFactura";
import { TipoReporteRefacturacion } from '@shared/enums/TipoReporteRefacturacion';
import { ReporteRefacturacionDTO } from '@shared/models/facturacion';
import { Motivo } from '@shared/enums/Motivo';

@Component({
  selector: 'app-modal-refacturacion',
  templateUrl: './modal-refacturacion.component.html'
})
export class ModalRefacturacionComponent implements OnInit, AfterViewChecked {
  @Input() tipoReporte: TipoReporteRefacturacion;
  @Input() factura: any;
  @Input() refacturacion: RefacturacionFactura;
  @Input() facturaAnticipada: ReporteRefacturacionDTO;
  protected readonly TipoReporteRefacturacion = TipoReporteRefacturacion;
  facturacionBaseUrl = environment.apiServer.facturacionBaseUrl;
  clientesBaseUrl = environment.apiServer.clientesBaseUrl;
  guardando: boolean = false;
  archivoSubido : string;
  error: string;
  // forms
  form: UntypedFormGroup;
  checkMultiplesMotivos: UntypedFormGroup;
  //lista de selección
  plazo = { nombre: "Plazo", codigo: 0 };
  erroresImpositivos = { nombre: "Errores Impositivos", codigo: 1 };
  otros={ nombre: "Otros", codigo: 2 };
  motivosParaCheckear = [this.plazo, this.erroresImpositivos,this.otros];
  motivo = Motivo;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef,
    private facturacionService: FacturacionService,
    private facturaPrefijoPipe: FacturaPrefijoPipe,
    private facturaNumeroPipe: FacturaNumeroPipe,
    private fb: UntypedFormBuilder,
    private messageService:MessageService) {}

  // hooks
  ngOnInit() {
    this.crearFormulario();
    this.inicializarComponente();
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  // form
  crearFormulario(){
    this.form = this.formBuilder.group({
      plazoFormControl:[''],
      motivoFormControl: ['', this.tipoReporte === TipoReporteRefacturacion.Manual ? Validators.required : null],
      comentariosFormControl: ['', Validators.required]
    });
  }

  keysTipoMotivos(): Array<string> {
    let keys = Object.keys(this.motivo);
    keys = keys.slice(keys.length / 2);
    keys = keys.slice(0, 3);
    return keys;
  }

  inicializarComponente(){
    this.checkMultiplesMotivos = this.formBuilder.group({
      nombreCondicion: this.fb.array([])
    });
    this.guardando = false;
  }

  // llamadas al service
  onSubmit() {
    this.guardando = true;

    switch (this.tipoReporte) {
      case TipoReporteRefacturacion.Manual:
        this.emitirRefacturacionManual();
        break;
      case TipoReporteRefacturacion.Devolucion:
        this.emitirRefacturacionPorDevolucionLitros();
        break;
      default:
        this.emitirRefacturacionPorDespacho();
        break;
    }      
  }

  mapFormToDto(): RefacturacionFactura {
    const refacturacion = new RefacturacionFactura();
    refacturacion.detalle = this.comentariosFormControl.value;
    refacturacion.nombreArchivoAdjunto = this.archivoSubido;
    refacturacion.usuarioSolicitador = this.obtenerStringUsuarioSolicitador();
    return refacturacion;
  }

  emitirRefacturacionManual() {
    const refacturacion = this.mapFormToDto();
    refacturacion.motivo = this.motivoFormControl.value;
    refacturacion.facturaId = this.factura.id;
    if (this.motivoFormControl.value === Motivo.Plazo) {
      refacturacion.plazo = Number(this.plazoFormControl.value);
    }
    this.facturacionService.emitirRefacturacionManual(refacturacion)
      .subscribe(
        () => this.handleRefacturacionResponse(this.factura.prefijo, this.factura.numeroComprobante),
        () => this.handleRefacturacionError()
      );
  }

  emitirRefacturacionPorDevolucionLitros() {
    const refacturacion = this.mapFormToDto();
    refacturacion.facturaId = this.facturaAnticipada.comprobanteId;
    this.facturacionService.emitirRefacturacionPorDevolucionLitros(refacturacion)
      .subscribe(
        () => this.handleRefacturacionResponse(Number(this.facturaAnticipada.prefijoComprobante), Number(this.facturaAnticipada.numeroComprobante)),
        () => this.handleRefacturacionError()
      );
  }

  emitirRefacturacionPorDespacho() {
    const refacturacion = this.mapFormToDto();
    refacturacion.estado = 0;
    refacturacion.aerovaleId = this.refacturacion.aerovaleId;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    this.facturacionService.emitirRefacturacionPorDespacho(refacturacion)
      .subscribe(
        () => this.handleRefacturacionResponse(),
        () => this.handleRefacturacionError()
      );
  }

  handleRefacturacionResponse(prefijo?: number, numero?: number) {
    const mensaje = `Se ha realizado correctamente la refacturación de la factura ${
      prefijo && numero ? this.obtenerPrefijoNumeroDeFactura(prefijo, numero) : ""
    }`;
  
    this.messageService.showSuccessMessage(mensaje);
    this.guardando = false;
    this.activeModal.close();
  }
  
  handleRefacturacionError() {
    this.messageService.showErrorMessage("Hubo un error al realizar la refacturación");
    this.guardando = false;
    this.activeModal.close();
  }

  // Validaciones
  puedeSolicitarRefactura(): boolean
  {
    console.log(this.motivoFormControl.value)
    if(this.tipoReporte === TipoReporteRefacturacion.Manual){
      let puede=false;
      if (this.motivoFormControl.value===Motivo.Plazo)
      {
        puede=(this.form.valid && this.archivoSubido!=null && this.plazoFormControl.value != null && this.plazoFormControl.value != '');
      }
      if (this.motivoFormControl.value== Motivo.Impuestos || this.motivoFormControl.value == Motivo.Otros)
      {
        puede=(this.archivoSubido!=null && this.comentariosFormControl.value!=null && this.comentariosFormControl.value.trim() !== '')
      }
      return puede;
    } else{
        return this.form.valid;
    }
  }

  onArchivoSubido(event){
    this.archivoSubido = event;
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46;
  }

  // getters
  obtenerPrefijoNumeroDeFactura(prefijo: number, numero: number){
    return "Prefijo: "+this.facturaPrefijoPipe.transform(prefijo) +", " + "Número: "+ this.facturaNumeroPipe.transform(numero);
  }

  obtenerStringUsuarioSolicitador(){
    return this.facturacionService.obtenerStringSolicitador();
  }

  get seleccionoPlazo(): boolean{
    return (this.motivoFormControl.value===Motivo.Plazo);
  }

  get motivoFormControl(){
    return this.form.controls.motivoFormControl;
  }

  get plazoFormControl(){
    return this.form.controls.plazoFormControl;
  }

  get comentariosFormControl(){
    return this.form.controls.comentariosFormControl;
  }
}
